import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { SkillgarageLogo, Hamburger } from '../../../../images';

const MobileNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Hide navbar on /course-details/:id/checkout
  const isCheckoutPage = /^\/course-details\/[^/]+\/checkout$/.test(location.pathname);
  if (isCheckoutPage) return null; // completely hidden (display: none)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="w-full h-[72px] flex justify-between py-[12px] px-[16px] bg-white shadow-[1px_3px_20px_0px_#01010112] block lg:hidden">
      {/* Logo Section */}
      <Link to="/" className="flex items-center space-x-2" aria-label="Go to homepage">
        <img
          src={SkillgarageLogo}
          alt="TheSkill Garage Logo"
          className="h-[40px] w-[91px]"
        />
      </Link>

      {/* Hamburger Menu */}
      <button
        onClick={toggleMenu}
        className="focus:outline-none"
        aria-label="Menu"
      >
        <img src={Hamburger} alt="Menu" className="h-[48px] w-[48px]" />
      </button>
    </header>
  );
};

export default MobileNavbar;
